/**
 * Modal.js
 * Created by calhosh on 6/5/2020.
 */
import React from 'react';
import styled from 'styled-components';
import {color, lightColor} from '@ey/styled-theme';
import PropTypes from 'prop-types';
import {
	MotifModal,
	MotifModalHeader,
	MotifModalBody,
	MotifModalFooter,
	MotifButton,
	MotifIconButton
} from '@ey-xd/motif-react';
import {SVGICONS} from '@ey/icons';
import {Theme} from '../../utils/uiconstants';
import {getTheme} from '../../utils/utils';
import ErrorSummary from '../ErrorSummary/ErrorSummary';

function Modal(props) {
	const {
		show,
		onHide,
		onOkClick,
		title,
		children,
		isOkButtonDisabled,
		isCancelButtonDisabled,
		showButtons,
		hideCloseButton,
		hideConfirmButton,
		hideCancelButton,
		confirmBtnTitle,
		closeBtnTitle,
		closeTitle,
		modalsize,
		modalbodystyle,
		modalContainerClass,
		modalonmodal,
		disableClose,
		hideConfirmAndCloseButton = true,
		isCancelAndCloseButtonDisabled,
		confirmAndcloseBtnTitle,
		onConfirmAndCloseClick
	} = props;

	return (
		<StyledMotifModal
			show={show}
			onClose={onHide}
			className={modalsize + ' ' + modalContainerClass}
			modalonmodal={modalonmodal}
			theme={getTheme()}
			focusTrapOptions={{
				allowOutsideClick: true
			}}
		>
			<StyledModalHeader
				visibility={hideCloseButton}
				closeModalButton={
					<MotifIconButton
						type="button"
						onClick={onHide}
						className="motif-modal--header-icon-button"
						title={closeTitle}
						disabled={disableClose}
					>
						<SVGICONS
							styleName="medium"
							name="close-outline"
							hoverText={closeTitle}
						/>
					</MotifIconButton>
				}
			>
				{title}
			</StyledModalHeader>
			<StyledModalBody className={modalbodystyle}>
				<ErrorSummary />
				{children}
			</StyledModalBody>
			{showButtons && (
				<StyledModalFooter>
					{!hideConfirmAndCloseButton && (
						<MotifButton
							type="button"
							variant="primary-alt"
							disabled={isCancelAndCloseButtonDisabled}
							onClick={onConfirmAndCloseClick}
						>
							{confirmAndcloseBtnTitle}
						</MotifButton>
					)}
					{!hideConfirmButton && (
						<MotifButton
							type="button"
							variant="secondary"
							onClick={onOkClick}
							disabled={isOkButtonDisabled}
						>
							{confirmBtnTitle}
						</MotifButton>
					)}
					{!hideCancelButton && (
						<MotifButton
							type="button"
							variant="secondary"
							disabled={isCancelButtonDisabled}
							onClick={onHide}
						>
							{closeBtnTitle}
						</MotifButton>
					)}
				</StyledModalFooter>
			)}
		</StyledMotifModal>
	);
}

export default Modal;

Modal.propTypes = {
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	modalsize: PropTypes.string,
	confirmBtnTitle: PropTypes.string,
	closeBtnTitle: PropTypes.string,
	modalbodystyle: PropTypes.string,
	modalContainerClass: PropTypes.string,
	showButtons: PropTypes.bool,
	hideCloseButton: PropTypes.bool,
	hideConfirmButton: PropTypes.bool,
	hideCancelButton: PropTypes.bool,
	isOkButtonDisabled: PropTypes.bool,
	isCancelButtonDisabled: PropTypes.bool,
	disabled: PropTypes.bool,
	show: PropTypes.bool,
	hideConfirmAndCloseButton: PropTypes.bool,
	isCancelAndCloseButtonDisabled: PropTypes.bool,
	confirmAndcloseBtnTitle: PropTypes.string
};

const StyledMotifModal = styled(MotifModal)`
	.motif-modal-overlay {
		padding: 1rem;
	}
	&.motif-modal-content {
		width: 100%;
		max-width: 100%;
		height: 100%;
		max-height: 100%;

		&.small {
			width: 50%;
			max-width: 50%;
			height: auto;
			max-height: auto;
		}

		&.medium {
			width: 72%;
			max-width: 72%;
			height: calc(100vh - 4rem);
			max-height: auto;
		}

		&.message {
			width: 30%;
			max-width: 30%;
			height: auto;
			max-height: auto;
		}
	}

	.motif-modal-body {
		padding: 0;
		position: relative;
		font-size: 1.2rem;
	}
`;

const StyledModalHeader = styled(MotifModalHeader)`
	color: ${lightColor[`white`]} !important;
	padding: 1.2rem 1rem !important;
	height: 6rem !important;
	background: ${lightColor[`grey500`]} !important;
	.motif-modal-headline {
		color: ${lightColor[`white`]} !important;
		font-weight: bold !important;
		font-size: 1.7rem !important;
		padding: 0 !important;
		margin-left: 1rem;
	}
	.motif-modal--header-icon-button {
		${({visibility}) => visibility && `visibility: hidden !important;`}
		box-shadow: none !important;
		height: 100% !important;
		svg {
			fill: ${lightColor[`white`]} !important;
			width: 2.4rem !important;
			height: 2.4rem !important;
			path {
				fill: ${lightColor[`white`]} !important;
			}
		}
		&:hover,
		&:focus {
			background: ${lightColor[`grey500`]} !important;
		}
	}
`;
const StyledModalBody = styled(MotifModalBody)`
	overflow: hidden !important;
	&.modalMinHeight {
		min-height: 20rem !important;
	}
`;
const StyledModalFooter = styled(MotifModalFooter)`
	padding: 1rem 2rem !important;
	border-width: 0.1rem !important;
	button {
		font-size: 1.4rem !important;
		padding: 0.7rem 2rem !important;
		border-width: 0.1rem !important;
		min-height: 3.8rem !important;
		min-width: 8.8rem;
	}
`;
